<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text alt">
                        <p class="main">Send Money</p>
                    </div>
                </div>
            </div>
            <!--        Intro Text-->
            <div class="option-component">
                <div class="intro-text">
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="big">
                                Money Transfer Made Easy: You have three options
                            </p>
                        </div>
                        <div class="col-sm-6">
                            <p class="small">
                                Transfer to any other account in any bank in Nigeria,
                                transfer to phone (beneficiary will a link to access the money),
                                transfer to self (between your accounts)
                            </p>
                        </div>
                    </div>
                </div>

                <div class="options">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div @click="goToFundsTransfer()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480">
                                        <path d="M472 48H320c-4.4 0-8 3.6-8 8v24h-24c-4.4 0-8 3.6-8 8v91.1L222.1 208H8c-4.4 0-8 3.6-8 8v208c0 4.4 3.6 8 8 8h160c4.4 0 8-3.6 8-8v-22.6l86.7 14.4c0.4 0.1 0.9 0.1 1.3 0.1h120c11.4 0 21.9-6.1 27.6-16H440c4.4 0 8-3.6 8-8v-24h24c4.4 0 8-3.6 8-8V56C480 51.6 476.4 48 472 48zM160 416H16V224h144V416zM328 64h136v175.1c-0.1-5-1.5-10.1-4.2-14.8 -2.8-4.9-6.9-9-11.8-11.8V88c0-4.4-3.6-8-8-8H328V64zM296 96h136v112h-16v-72c0-4.4-3.6-8-8-8s-8-3.6-8-8 -3.6-8-8-8h-56c-4.4 0-8 3.6-8 8s-3.6 8-8 8 -8 3.6-8 8v72h-16V96zM400 142.6V208h-72v-65.4c6.8-2.4 12.2-7.8 14.6-14.6h42.7C387.8 134.8 393.2 140.2 400 142.6zM432 384h-16c0-6.3-1.9-12.5-5.4-17.8 16.7-5.8 25.5-24.1 19.6-40.8 -0.9-2.5-2.1-5-3.6-7.2 1.9-0.7 3.7-1.5 5.4-2.6V384zM432 256h-32c-4.4 0-8 3.6-8 8s3.6 8 8 8h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-4.4 0-8 3.6-8 8s3.6 8 8 8h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-4.4 0-8 3.6-8 8s3.6 8 8 8h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264.7L176 385.2V224h48c1.2 0 2.5-0.3 3.6-0.8L280 196.9V216c0 4.4 3.6 8 8 8h144c8.8 0 16 7.2 16 16S440.8 256 432 256zM448 352v-84.4c10-5.7 15.7-16 16-26.6V352H448z"></path>
                                        <path d="M112 336c-17.7 0-32 14.3-32 32 0 17.7 14.3 32 32 32s32-14.3 32-32C144 350.3 129.7 336 112 336zM112 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16S120.8 384 112 384z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">To Other Banks | Rubies</p>
                                <p class="sub">Send money to all banks in Nigeria</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div @click="goToPhoneTransfer()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                                        <path d="M35.5 31c-0.6 0-1 0.4-1 1V46h-30V8h30v14c0 0.6 0.4 1 1 1s1-0.4 1-1V4.4C36.5 2 34.5 0 32.1 0H6.9C4.5 0 2.5 2 2.5 4.4v51.2C2.5 58 4.5 60 6.9 60h25.2c2.4 0 4.4-2 4.4-4.4v-23.6C36.5 31.4 36.1 31 35.5 31zM6.9 2h25.2C33.4 2 34.5 3.1 34.5 4.4V6h-30V4.4C4.5 3.1 5.6 2 6.9 2zM32.1 58H6.9C5.6 58 4.5 56.9 4.5 55.6V48h30v7.6C34.5 56.9 33.4 58 32.1 58z"></path>
                                        <path d="M19.5 49c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4S21.7 49 19.5 49zM19.5 55c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2S20.6 55 19.5 55z"></path>
                                        <path d="M15.5 5h4c0.6 0 1-0.4 1-1s-0.4-1-1-1h-4c-0.6 0-1 0.4-1 1S14.9 5 15.5 5z"></path>
                                        <path d="M22.5 5h1c0.6 0 1-0.4 1-1s-0.4-1-1-1h-1c-0.6 0-1 0.4-1 1S21.9 5 22.5 5z"></path>
                                        <path d="M56.5 26H20.9l10.3-10.3c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0L17.8 26.3c-0.1 0.1-0.2 0.2-0.2 0.3 -0.1 0.2-0.1 0.5 0 0.8 0.1 0.1 0.1 0.2 0.2 0.3l12 12C30 39.9 30.2 40 30.5 40s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4L20.9 28H56.5c0.6 0 1-0.4 1-1S57.1 26 56.5 26z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">To Phone Number</p>
                                <p class="sub">Send money to all any phone number</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div @click="goToOwnTransfer()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480.1 480.1">
                                        <path d="M432.1 24.1v72.1C352.6-9.9 202.1-31.4 96.1 48.1 13.8 109.8-20.1 217 11.9 314.8c1.1 3.3 4.1 5.5 7.6 5.5 0.8 0 1.7-0.1 2.5-0.4 4.2-1.4 6.5-5.9 5.1-10.1 -7.4-22.5-11.1-46.1-11.1-69.8C16 116.3 116.3 16 240 16c73.3 0 142 35.9 183.9 96h-87.9v16h112v-104H432.1z"></path>
                                        <path d="M468.2 165.3c-1.5-4.2-6.1-6.3-10.2-4.8 -4 1.4-6.2 5.7-5 9.8 38.5 117.6-25.6 244.1-143.2 282.7 -94 30.8-197.1-3.7-253.6-84.9h87.9v-16h-112v104h16v-72.1c79.5 106.1 229.9 127.6 336 48.1C466.3 370.3 500.2 263.1 468.2 165.3z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">From me to me</p>
                                <p class="sub">Send money between your rubies account</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";


    export default {
        name: "sendMoney",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return { }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateFullBankList',
                'updateCurrentTransferPhoneNo',
            ]),

            backButton(){
                this.updateInsideCurrentPage('dashboard');
                this.updateSideBarPage('dashboard');
            },
            goToFundsTransfer(){
                //start app loading
                this.updateAppLoading(true);

                axios
                    .post('/bankfromaccount', {
                        accountnumber: "0000000001",
                    }, {'Authorization': this.getDataOnLogin.authorization})
                    .then(response => {
                        //stop app loading
                        this.updateAppLoading(false);

                        // // console.log('Bank From Account Response ==>>', response.data)

                        this.updateFullBankList (response.data.fullbanklist);

                        //Update the current sub component in the store
                        this.updateInsideCurrentPage('fundsTransfer')
                    })
            },
            goToPhoneTransfer(){
                // update current transfer phone number
                this.updateCurrentTransferPhoneNo([undefined, ''])

                //Update the current sub component in the store
                this.updateInsideCurrentPage('phoneTransfer')
            },
            goToOwnTransfer(){
                //Update the current sub component in the store
                this.updateInsideCurrentPage('ownTransfer')
            },
        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>

</style>